import map from "lodash/fp/map";
import constants from "../../core/constants";
import { formatKey } from "../../core/utils";
import moment from "moment";

class BulkInvoiceItemTypesUploadsPageTransform {
  constructor() {
    "ngInject";

    this.fields = [
      {
        title: "Operator",
        name: "userName",
      },
      {
        title: "Invoice Item Type",
        name: "invoice_item_type",
      },
      {
        title: "Creation Date",
        name: "createdAt",
      },
      {
        title: "City",
        name: "cityName",
      },
      {
        title: "Pending Records",
        name: "number_of_pending_records",
      },
      {
        title: "Successful Records",
        name: "number_of_successful_records",
      },
      {
        title: "Failed Records",
        name: "number_of_failed_records",
      },
      {
        title: "Total amount processed",
        name: "total_successful_amount",
      },
      {
        title: "Currency",
        name: "cityCurrency",
      },
    ];
  }

  justify(data) {
    const format = (item) => {
      item.userName = item.user.name;
      item.createdAt = moment(item.createdAt).format(constants.dateFormat);
      item.cityName = item.city.name;
      item.cityCurrency = item.city.currency;
      item.total_amount /= 100;
      item.invoice_item_type = formatKey(item.invoice_item_type);
      item.number_of_pending_records =
        item.number_of_records -
        item.number_of_successful_records -
        item.number_of_failed_records;
      return item;
    };
    return map(format)(data);
  }
}

export default BulkInvoiceItemTypesUploadsPageTransform;



// WEBPACK FOOTER //
// ./src/pages/bulkInvoiceItemTypesUploads/bulkInvoiceItemTypesUploads.transforms.js